import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import '../../styles/welcome.css';

export const PageWrapper = styled.div.attrs({ className: 'welcome-page' })`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow-x: hidden;
  background: linear-gradient(145deg, #041f24 0%, #0c4a5c 38%, #14464f 62%, #1f6d68 100%);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom right, #041f24, #0c4a5c, #14464f, #1f6d68);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.25), transparent, rgba(0, 0, 0, 0.4));
    pointer-events: none;
  }

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export const FormContainer = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  padding: 40px;
  border-radius: 24px;
  width: 100%;
  max-width: 440px;
  position: relative;
`;

/** Matches welcome “brand pill” so the QQ mark reads on the hero gradient. */
const authBrandingPill = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto 28px;
  padding: 8px 16px 8px 10px;
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
`;

export const LogoContainer = styled.div`
  ${authBrandingPill}
`;

/** Same pill as LogoContainer; used on full-page login/signup to go to Welcome. */
export const BrandingLink = styled(Link)`
  ${authBrandingPill}
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.85);
    outline-offset: 3px;
  }
`;

export const Logo = styled.img`
  width: 44px;
  height: 44px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const BrandName = styled.h1`
  color: #14464f;
  font-size: 22px;
  font-weight: bold;
  margin: 0;
  font-family: 'Josefin Sans', sans-serif;
  letter-spacing: 0.02em;
`;

export const Title = styled.h2`
  color: rgba(255, 255, 255, 0.95);
  margin: 20px 0;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.75);

  &:hover {
    color: #ffffff;
  }
`;

export const SwitchText = styled.p`
  text-align: center;
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.82);
`;

export const SwitchLink = styled.span`
  color: #b8efe8;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;

  &:hover {
    color: #e6fffb;
  }
`; 